<footer class="hide-for-print footer">
  <div class="footer__content">
    <span class="footer__content__copyright" [innerHTML]="'&copy; ' + currentYear +
        ' Gallagher | All Rights Reserved.' + ' Powered by Core.'"></span>
    <ul class="footer__content__links">
      <li>
        <a href="//policy.cookiereports.com/2f840f2e-en-gb.html">Cookie Policy</a>
      </li>
      <!--      <li><a href="/">Accessibility</a></li>-->
    </ul>
  </div>

  <img [alt]="getSiteName()" [src]="logoUrl" class="footer__logo" />
</footer>
